var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_8377)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.502103 2.78787C0.823594 2.46638 1.25963 2.28577 1.71429 2.28577C2.02988 2.28577 2.28571 2.5416 2.28571 2.8572C2.28571 3.17279 2.02988 3.42862 1.71429 3.42862C1.56273 3.42862 1.41739 3.48883 1.31022 3.59599C1.20306 3.70315 1.14286 3.8485 1.14286 4.00005V14.2858C1.14286 14.4373 1.20306 14.5827 1.31022 14.6898C1.41739 14.797 1.56273 14.8572 1.71429 14.8572H14.2857C14.4373 14.8572 14.5826 14.797 14.6898 14.6898C14.7969 14.5827 14.8571 14.4373 14.8571 14.2858V4.00005C14.8571 3.8485 14.7969 3.70316 14.6898 3.59599C14.5826 3.48883 14.4373 3.42862 14.2857 3.42862H12C11.6844 3.42862 11.4286 3.17279 11.4286 2.8572C11.4286 2.5416 11.6844 2.28577 12 2.28577H14.2857C14.7404 2.28577 15.1764 2.46638 15.4979 2.78787C15.8194 3.10936 16 3.5454 16 4.00005V14.2858C16 14.7404 15.8194 15.1765 15.4979 15.4979C15.1764 15.8194 14.7404 16.0001 14.2857 16.0001H1.71429C1.25963 16.0001 0.823593 15.8194 0.502103 15.4979C0.180612 15.1765 0 14.7404 0 14.2858V4.00005C0 3.5454 0.180612 3.10936 0.502103 2.78787Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99999 0C4.31558 0 4.57142 0.255837 4.57142 0.571429V5.14286C4.57142 5.45845 4.31558 5.71429 3.99999 5.71429C3.6844 5.71429 3.42856 5.45845 3.42856 5.14286V0.571429C3.42856 0.255837 3.6844 0 3.99999 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C12.3156 0 12.5714 0.255837 12.5714 0.571429V5.14286C12.5714 5.45845 12.3156 5.71429 12 5.71429C11.6844 5.71429 11.4286 5.45845 11.4286 5.14286V0.571429C11.4286 0.255837 11.6844 0 12 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42856 2.8572C3.42856 2.5416 3.6844 2.28577 3.99999 2.28577H9.71427C10.0299 2.28577 10.2857 2.5416 10.2857 2.8572C10.2857 3.17279 10.0299 3.42862 9.71427 3.42862H3.99999C3.6844 3.42862 3.42856 3.17279 3.42856 2.8572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2334 6.99857C11.4709 7.20639 11.495 7.5674 11.2872 7.8049L7.28719 12.3763C7.09036 12.6013 6.75342 12.6365 6.51429 12.4572L4.22857 10.7429C3.9761 10.5535 3.92493 10.1954 4.11429 9.9429C4.30364 9.69043 4.66182 9.63926 4.91429 9.82861L6.77606 11.2249L10.4271 7.05233C10.6349 6.81482 10.9959 6.79075 11.2334 6.99857Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_8377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTick);
export default __webpack_public_path__ + "static/media/calendar-tick.cf4969232f62084dd0a11c06d1dc40e2.svg";
export { ForwardRef as ReactComponent };